var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 44 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 41.5a1 1 0 0 0 2 0 4.655 4.655 0 0 0-4-4.409V37a1 1 0 0 0-2 0v.091a4.43 4.43 0 0 0 0 8.818v4.937a2.575 2.575 0 0 1-2-2.346 1 1 0 0 0-2 0 4.655 4.655 0 0 0 4 4.409V53a1 1 0 0 0 2 0v-.091a4.43 4.43 0 0 0 0-8.818v-4.937a2.575 2.575 0 0 1 2 2.346zm-6 0a2.575 2.575 0 0 1 2-2.346v4.692a2.575 2.575 0 0 1-2-2.346zm6 7a2.575 2.575 0 0 1-2 2.346v-4.692a2.575 2.575 0 0 1 2 2.346z",
    fill: "#405b6c",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5a1 1 0 0 0-1 1V54a6.006 6.006 0 0 0 6 6h32a6.006 6.006 0 0 0 6-6V15a1 1 0 0 0-.293-.707l-14-14A1 1 0 0 0 29 0H6a6.006 6.006 0 0 0-6 6v6a1 1 0 0 0 2 0V6a4 4 0 0 1 4-4h22v8a6.006 6.006 0 0 0 6 6h8v38a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V16.5a1 1 0 0 0-1-1zM30 10V3.414L40.586 14H34a4 4 0 0 1-4-4z",
    fill: "#405b6c",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 53a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2H9v-3a1 1 0 0 0-2 0zM8 22h27a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2zM8 28h27a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2zM8 34h27a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2zM8 40h14a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2z",
    fill: "#405b6c",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.32581bb8973b1a6e9f9ae3f6d479910e.svg";
export { ForwardRef as ReactComponent };